import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import * as _ from "lodash";
import { SubmittedFormFilterService } from '../submitted-form-filter/submitted-form-filter.service';

@Component({
  selector: 'app-user-inspection-stats',
  templateUrl: './user-inspection-stats.component.html',
  styleUrls: ['./user-inspection-stats.component.scss']
})
export class UserInspectionStatsComponent implements OnInit {

  usersData = []
  public modalOpen: boolean;
  @Input() public user;

  teamUsers = [];
  filteredUsers = [];
  filteredUserDetails = [];
  dropdownSettings = {
    singleSelection: false,
    idField: "_id",
    textField: "name",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    // itemsShowLimit: 3,
    enableCheckAll: true,
    allowSearchFilter: true
  };
  constructor(
    public activeModal: NgbActiveModal,
    private filterDeatailservice: SubmittedFormFilterService
  ) { }



  ngOnInit() {
    this.usersData = Object.keys(this.user);
    this.filteredUserDetails = this.usersData;
    if(localStorage.getItem("userRole") && (localStorage.getItem("userRole") == "supervisor" || localStorage.getItem("userRole") == "webAdmin")) {
      this.filterDeatailservice.getInitialDataForSubmittedFilter().subscribe((data) => {
        this.teamUsers = data['data'] && data['data']['usersList'] && data['data']['usersList'].length > 0 ? data['data']['usersList'] : []
        this.teamUsers = _.filter(this.teamUsers, (user) => {
          return user['status'] != 0
        })

        let optedOperators = this.getOperatorIDs();
        if(optedOperators && optedOperators.length > 0) {
          this.filteredUsers = optedOperators;
          this.applyFilters();
        }
      })
    }
  }
  closeModal() {
    this.activeModal.dismiss();
  }


  getOperatorIDs() {
    let teams = JSON.parse(localStorage.getItem("teams"))
    let operators = [];
    if(teams && teams.length > 0) {
        let presentTeamId = localStorage.getItem("teamId")
        let presentTeamIndex = _.findIndex(teams, {teamDetails: {"_id": presentTeamId}})
        if(presentTeamIndex != -1) {
            let presentTeamOperators = teams[presentTeamIndex]['operators'];
            if(presentTeamOperators && presentTeamOperators.length > 0) {
                operators = _.map(presentTeamOperators, (operator) => {
                    return {
                        _id: operator['_id'],
                        name: operator['name']
                    }
                })
            }
        }
    }

    if(operators && operators.length > 0) {
        return operators;
    }
  }

  applyFilters() {
    if(this.filteredUsers && this.filteredUsers.length > 0) {
      this.filteredUserDetails = _.filter(this.usersData, (user) => {
        let index = _.findIndex(this.filteredUsers, (o) => {
          return o.name == user
        })
        if(index > -1) {
          return user;
        }
        this.filteredUserDetails = _.orderBy(this.filteredUserDetails, [user => user.toLowerCase()], ['asc'])
      })
    } else {
      this.filteredUserDetails = this.usersData;
      this.filteredUserDetails = _.orderBy(this.filteredUserDetails, [user => user.toLowerCase()], ['asc'])
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/user-inspection-stats/user-inspection-stats.component.ts